import {Module} from "wrapper6";
import Gumshoe from "gumshoejs";
import {debounce} from '../utils/_debounce';
import {isOnScreen} from '../utils/_is-on-screen';

var $ = jQuery;

export default class MobileSubmenu extends Module {

  ready(app) {

        this.highlightVisible();
        this.checkForFooterSpacing();
        this.checkForMorningCatch();
        window.addEventListener('resize', debounce(() => {
          this.checkForFooterSpacing();
          this.checkForMorningCatch();
        }, 150));
    }

  checkForFooterSpacing() {
    if ($(window).width() < 581) {
      var submenuHeight = $('#mobile-submenu').height();
      $('#main_footer').css('marginBottom', submenuHeight + 'px');
    } else {
      $('#main_footer').css('marginBottom', '0px');
    }
  }

  checkForMorningCatch() {
    if ($(window).width() < 581) {
      var submenuHeight = $('#mobile-submenu').height();
      var morningCatchButton = $('.morningcatch .mt-trigger');
      if (submenuHeight && morningCatchButton) {
        morningCatchButton.css('bottom', submenuHeight + 8 + 'px')
      }
    }
  }

  highlightVisible() {
    const ITEMS = document.querySelectorAll('#mobile-submenu .subitem-link');
    const HEADER = document.getElementById('main_header');
    const SUBMENU = document.getElementById('mobile-submenu');
    let offsetTop = HEADER ? HEADER.getBoundingClientRect().height : 0;
    let offsetBottom = SUBMENU ? SUBMENU.getBoundingClientRect().height : 0;
    offsetBottom += HEADER ? HEADER.getBoundingClientRect().height : 0;
    const ELEMENTS = [];
    let activeItem = null;

    if (ITEMS.length > 0) {
      for (let i = 0; i < ITEMS.length; i++) {
        const ITEM = ITEMS[i];
        const ID = ITEM.getAttribute('href').replace('#', '');
        const EL = document.getElementById(ID);

        if (EL) {
          ELEMENTS.push({
            item: ITEM,
            el: EL
          });
        }

      } // END FOR LOOP
      
      if (ELEMENTS.length > 0) {
        window.addEventListener('scroll', () => {
          for (let i = 0; i < ELEMENTS.length; i++) {
            const EL = ELEMENTS[i];
            if (isOnScreen(EL.el, offsetBottom, offsetTop)) {
              activeItem = EL.el;
              break;
            } else {
              activeItem = null;
            }
          } // END FOR

          for (let i = 0; i < ELEMENTS.length; i++) {
            const EL = ELEMENTS[i];
            if (activeItem === EL.el) {
              EL.item.parentElement.classList.add('active');
            } else {
              EL.item.parentElement.classList.remove('active');
            }
          } // END FOR
        })
      }
    }
  }
}